var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('six-digit-confirm-view',{attrs:{"loading":_vm.processingConfirmation},on:{"resend":_vm.codeResend,"submit":_vm.submit,"back":function($event){return _vm.$emit('back')}}})}
var staticRenderFns = []

export { render, staticRenderFns }